/**
 * Which flags the tile grid shows for the hand being entered: "R" on the round wind's tile,
 * "S" on the winner's seat wind and on the flower / season tile that matches that seat.
 *
 * ONE rule, used by both the host's screen (`views/play.ts`) and the guest's (`views/guestPlay.ts`),
 * so a guest sees exactly the flags the host would — they cannot drift apart. It only decides
 * what to SHOW as a hint; scoring itself always comes from the ruleset.
 *
 * A flag is only worth showing when the venue has that rule switched on (a flag for an
 * inactive rule would be a misleading hint), which is why each comes from `settings.toggles`.
 */

import type { HkosSettings } from '../rules/hkos';
import type { Wind } from '../rules/tiles';
import { seatWindOf } from './rotation';
import type { TileGridContext } from './tileGrid';

export function tileGridContextFor(
  settings: HkosSettings,
  /** Player ids in seating order: index 0 is East and the first dealer. */
  playerIds: readonly string[],
  /** Index (into `playerIds`) of this round's dealer. */
  dealerIndex: number,
  prevailingWind: Wind,
  /** The player chosen as the winner on the form. */
  winnerId: string | undefined,
): TileGridContext {
  const winnerIndex = Math.max(0, playerIds.indexOf(winnerId ?? ''));
  return {
    seatWind: seatWindOf(winnerIndex, dealerIndex),
    prevailingWind,
    showSeatWindBadge: settings.toggles.seatWindPung,
    showPrevailingWindBadge: settings.toggles.prevailingWindPung,
    showSeatFlowerBadge: settings.toggles.seatFlowerBonus,
  };
}
